import { render, staticRenderFns } from "./AboutProductShowcase.vue?vue&type=template&id=516c0864&"
import script from "./AboutProductShowcase.vue?vue&type=script&lang=js&"
export * from "./AboutProductShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports